import { AuthInnerRoutes } from "./types";

export const availableAuthRoutes: AuthInnerRoutes[] = [
  "signin",
  "register",
  "onboarding",
  "resetPassword",
  "noCompany",
  "verify",
  "email-verified",
  "accept-invite",
  "complete-profile",
];
